import { useMergeState } from '@/shared/lib/customHooks';

/**
 * Holds the refresh flag of the BioDirect shipment info drawer content. Starts isRefreshingTracking false on a merging state hook and hands back the state with its setter.
 *
 * @returns Drawer content state and its merging setter.
 */
export const useDrawerContent = () => {
  const [state, setState] = useMergeState({
    isRefreshingTracking: false,
  });

  return { state, setState };
};
